// [HIGHCHARTS-10-MIGRATION-TAG]: Find and delete/clean all places like this once the migration ends

import Highcharts from 'highcharts-v8';
import highchartsMore from 'highcharts-v8/highcharts-more';
import addSolidGauge from 'highcharts-v8/modules/solid-gauge';
import addHeatmap from 'highcharts-v8/modules/heatmap';
import addBoost from 'highcharts-v8/modules/boost';
import addExporting from 'highcharts-v8/modules/exporting';
import addXrange from 'highcharts-v8/modules/xrange';
import addDumbbell from 'highcharts-v8/modules/dumbbell';
import addPatternFill from 'highcharts-v8/modules/pattern-fill';
import HighchartsMulticolorSeries from 'highcharts-multicolor-series-v8';

export function getHighchartsV8() {
  return {
    Highcharts,
    highchartsMore,
    addSolidGauge,
    addHeatmap,
    addBoost,
    addExporting,
    addXrange,
    addDumbbell,
    addPatternFill,
    HighchartsMulticolorSeries,
  };
}
